import * as React from 'react';
import cx from 'classnames';

import * as styles from './styles.css';

export interface IStarProps {
  isActive: boolean;
  isHover: boolean;
}

export const Star = ({ isActive, isHover }: IStarProps) => {
  return (
    <div className={styles['container']}>
      <i className={cx(styles['star'], isActive && styles['active'], isHover && !isActive && styles['hover'])} />
    </div>
  );
};
